import { render } from "./Global.vue?vue&type=template&id=5c65e2d3&scoped=true"
import script from "./Global.vue?vue&type=script&lang=js"
export * from "./Global.vue?vue&type=script&lang=js"

import "./Global.vue?vue&type=style&index=0&id=5c65e2d3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c65e2d3"]])

export default __exports__